import axios, { AxiosHeaders } from 'axios';
import { environment } from "../../../environments/environment";

const axiosInstance = axios.create({
    baseURL: environment.backendApiUrl || 'http://localhost:3000',
});

let on401Callback: (() => Promise<void>) | null = null;

export function setOn401Handler(handler: () => Promise<void>) {
    on401Callback = handler;
}

axiosInstance.interceptors.request.use(config => {
    const token = localStorage.getItem('jwtToken');
    if (token) {
        config.headers = new AxiosHeaders({
            ...config.headers,
            Authorization: `Bearer ${token}`
        });
    }
    return config;
});

axiosInstance.interceptors.response.use(
    response => response,
    async (error) => {
        if (error.response?.status === 401 && on401Callback) {
            await on401Callback();
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;